<template>
  <div class="login-main">
    <router-view />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
    }
  },
  components: {
  },
  created() {
  }
}
</script>

<style scoped lang="stylus">

</style>
